module.exports = require("redis");


//////////////////
// WEBPACK FOOTER
// external "redis"
// module id = 47
// module chunks = 0